import { Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import CCADetails from "../_shark_models/CCADetails";
import ManagerBase from "./ManagerBase";

class CCADetailsManager extends ManagerBase {
	constructor () {
		super("CCADetailsManager");
		this.remoteClassName = "cca-details";
	}

	async getByCCA (cca) {
		const rd = NousCore.api.createRequest({ item: { cca } });
		const requestedAction = "get-by-cca";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const ccaDetailsList = Shark.getInstanceList(CCADetails, data.items);

						return {
							data: ccaDetailsList,
							requestedAction,
							status: "ok"
						};
					}
					case 404:
						return {
							data: "",
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}

	getByGuid (guid) {
		const rd = NousCore.api.createRequest({ item: {guid} });
		const requestedAction = "get-by-guid";
	
		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const item = new CCADetails(data.items[0]);
		
						return {
							data: item,
							requestedAction,
							status: "ok"
						};	
					}
					case 99:
						return {
							data: "",
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}

	// save (item) {
	// 	const rd = NousCore.api.createRequest({ item: item.export() });
	// 	const requestedAction = item.guid === "" ? "insert" : "update";
	
	// 	return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
	// 	.then(data => {
	// 		if (data.isSuccess) {
	// 			switch (data.rc) {
	// 				case 1:
	// 					item.import(data.items[0]);
	// 					item.clean();
		
	// 					return {
	// 						data: item,
	// 						requestedAction,
	// 						status: "ok"
	// 					};	
	// 					break;
	// 				case 99:
	// 					return {
	// 						data: "",
	// 						requestedAction,
	// 						status: "ko"
	// 					};
	// 			}
	// 		}
	// 	});
	// }
}

const ccaDetailsManager = new CCADetailsManager();

Shark.registerController(ccaDetailsManager);

export default ccaDetailsManager;
